import { FlexBox } from "./style";
import { BiEdit, BiMailSend } from "react-icons/bi";
import { FiCamera } from "react-icons/fi";
import InviteButton from "../InviteButton";
import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router";
import { BiDotsVerticalRounded } from "react-icons/bi";

interface HeaderProps {
  activeComponent: string;
  onViewProfileClick: () => void;
}

const Header = ({ activeComponent, onViewProfileClick }: HeaderProps) => {
  const storedToken = sessionStorage.getItem("token");
  const token = `Bearer ${storedToken}`;
  const [avatar, setAvatar] = useState("");
  const [name, setName] = useState("");
  const navigate = useNavigate();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const Authorization = {
    Authorization: token,
    "Content-Type": "application/json",
  };

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_ENDPOINT}/getme`, {
        headers: Authorization,
      })
      .then((res: any) => {
        if (res.data.result.image !== "") {
          setAvatar(res.data.result.image);
        } else {
          setAvatar("image/hush-logo.png");
        }
        if (res.data.result.firstname && res.data.result.lastname !== "") {
          setName(res.data.result.firstname + " " + res.data.result.lastname);
        } else if (res.data.result.username !== "") {
          setName(res.data.result.username);
        } else {
          setName("Pls update name");
        }
      })
      .catch((err) => {
        if (err && err.response.status === 409) {
          navigate("/login");
        } else {
        }
      });
  }, [Authorization, navigate]);

  return (
    <div>
      <FlexBox>
        <div>
          <img src="image/hush-logo.png" alt="logo" />
        </div>
        <div>
          {activeComponent === "contacts" && (
            <InviteButton
              spanText="send invite"
              icon={<BiMailSend color="#fff" />}
              CustomButtonClick={() => {
                console.log("love");
              }}
            />
          )}
          <div onClick={onViewProfileClick}>
            <img src={avatar} alt="profile-pic" />
            <span>{name}</span>
            <BiDotsVerticalRounded />
          </div>
        </div>
        <div>
          {activeComponent === "contacts"
            ? "contacts"
            : activeComponent === "callLogs"
            ? "call logs"
            : activeComponent === "myProfile"
            ? "my profile"
            : "chats"}
        </div>
        {activeComponent === "chats" && (
          <div>
            <FiCamera size={22} color="#000" />
            <BiEdit size={22} color="#000" />
          </div>
        )}
        {activeComponent === "contacts" && (
          <div>
            <InviteButton
              spanText="send invite"
              icon={<BiMailSend color="#fff" />}
              CustomButtonClick={() => {
                console.log("love");
              }}
            />
          </div>
        )}
      </FlexBox>
    </div>
  );
};

export default Header;
